import { useEffect, useRef } from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  TextareaAutosize,
  DialogActions,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    background: theme.palette.mode === 'light'
      ? '#FFFFFF'
      : 'linear-gradient(145deg, #121212 0%, #1a1a1a 100%)',
    boxShadow: theme.palette.mode === 'light'
      ? '0 4px 20px 0 rgba(0, 0, 0, 0.1)'
      : '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
    border: theme.palette.mode === 'light'
      ? '1px solid rgba(0, 0, 0, 0.1)'
      : '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '16px',
  },
}));

const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  minHeight: '100px',
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.mode === 'light'
      ? 'rgba(0, 0, 0, 0.1)'
      : 'rgba(255, 255, 255, 0.2)'}`,
  background: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(255, 255, 255, 0.1)',
  color: theme.palette.mode === 'light'
    ? 'rgba(0, 0, 0, 0.87)'
    : 'rgba(255, 255, 255, 0.9)',
  fontFamily: theme.typography.fontFamily,
  fontSize: '1rem',
  resize: 'none',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.08)'
      : 'rgba(255, 255, 255, 0.12)',
  },
  '&:focus': {
    background: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.1)'
      : 'rgba(255, 255, 255, 0.15)',
    outline: 'none',
    borderColor: theme.palette.primary.main,
  },
  '&::placeholder': {
    color: theme.palette.mode === 'light'
      ? 'rgba(0, 0, 0, 0.6)'
      : 'rgba(255, 255, 255, 0.6)',
  },
}));

const GradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(45deg, ${
    theme.palette.primary.main
  } 30%, ${
    theme.palette.primary.light
  } 90%)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 700,
}));

const HistoryDialog = ({
  open,
  reason,
  isSubmittingReject,
  onChangeReason,
  onReject,
  onClose,
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.focus();
        }
      }, 100);
    }
  }, [open]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
    <DialogTitle sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Box>
        <GradientText variant="h6">Motivo da Reprovação</GradientText>
        <DialogContentText>Por favor, informe o motivo da rejeição.</DialogContentText>
      </Box>
      <IconButton
        sx={{
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main',
          },
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box>
          <StyledTextarea
            ref={textareaRef}
            fullWidth
            label="Motivos (mínimo 15 caracteres)"
            name="motivoDaReprovacao"
            value={reason}
            onChange={(event) => { onChangeReason(event.target.value) }}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 2 }}>
        <Button
          // variant="contained"
          // color="error"
          onClick={onClose}
          disabled={isSubmittingReject}
          // startIcon={<CancelIcon />}
          // sx={{
          //   background: (theme) => (
          //     `linear-gradient(45deg, ${
          //       theme.palette.error.main
          //     } 30%, ${
          //       theme.palette.error.light
          //     } 90%)`
          //   ),
          //   boxShadow: (theme) => `0 4px 14px 0 ${theme.palette.error.main}40`,
          //   '&:hover': {
          //     boxShadow: (theme) => `0 6px 20px 0 ${theme.palette.error.main}60`,
          //   },
          // }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={onReject}
          startIcon={isSubmittingReject ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            <CheckCircleIcon />
          )}
          disabled={reason.length < 15 || isSubmittingReject}
          sx={{
            background: (theme) => (
              `linear-gradient(45deg, ${
                theme.palette.success.main
              } 30%, ${
                theme.palette.success.light
              } 90%)`
            ),
            boxShadow: (theme) => `0 4px 14px 0 ${theme.palette.success.main}40`,
            '&:hover': {
              boxShadow: (theme) => (
                `0 6px 20px 0 ${theme.palette.success.main}60`
              ),
            },
          }}
        >
          {isSubmittingReject ? 'Aguarde' : 'Salvar'}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default HistoryDialog;
